import { each, extend, range } from 'underscore';

export const getColumnSolidBorderStyle = (startIndex = 0, endIndex = 2) => {
  const cellStyle = {};

  each(range(startIndex, endIndex), index => extend(cellStyle, {
    [`& thead.header tr th:nth-child(${index + 1}), & tbody tr td:nth-child(${index + 1})`]: {
      '&:not(:last-child)': {
        borderRight: '1px solid #EDEBE9',
      },
    },
    [`& tbody tr:hover td:nth-child(${index + 1}), & tbody tr.row-selected td:nth-child(${index + 1}), & tbody tr.row-selected:hover td:nth-child(${index + 1})`]: {
      '&:not(:last-child)': {
        borderRight: '1px solid #FFFFFF',
      },
    },
    [`& tbody tr.aggregated-row:hover td:nth-child(${index + 1})`]: {
      '&:not(:last-child)': {
        borderRight: '1px solid #EDEBE9',
      },
    },
  }));

  extend(cellStyle, {
    // startIndex will be the primary column, use 14px font.
    [`& tbody tr td:nth-child(${startIndex + 1})`]: {
      fontSize: '14px',
    },
  });

  if (startIndex !== 2) {
    extend(cellStyle, {
      '& tbody tr td:nth-child(3)': {
        fontSize: '12px !important', // Override the global primary column font size
      },
    });
  }

  const style = {
    '& .table-container table.table': {
      ...cellStyle,
    },
  };

  return style;
};
